import React, { useRef } from 'react';
import { LuTriangleAlert } from 'react-icons/lu';
import { Modal } from './Modal';
import Button from './Button';

/** Confirmation dialog. The cancel button takes the focus so Enter never confirms by accident. */
const ConfirmModal = ({
  isOpen,
  onClose,
  onConfirm,
  title,
  message,
  confirmLabel = 'Confirmer',
  cancelLabel = 'Annuler',
  tone = 'danger',
  icon = LuTriangleAlert,
  loading = false,
}) => {
  const cancelRef = useRef(null);
  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title={title}
      icon={icon}
      iconTone={tone === 'danger' ? 'red' : 'brand'}
      size="sm"
      dismissible={!loading}
      initialFocusRef={cancelRef}
      footer={(
        <>
          <Button ref={cancelRef} onClick={onClose} disabled={loading}>{cancelLabel}</Button>
          <Button variant={tone === 'danger' ? 'danger' : 'primary'} onClick={onConfirm} loading={loading}>
            {confirmLabel}
          </Button>
        </>
      )}
    >
      <div className="text-sm leading-relaxed text-gray-600 dark:text-gray-300">{message}</div>
    </Modal>
  );
};

export default ConfirmModal;
